import { AccountShell } from "./AccountShell.js";
import { ManualContent } from "./ManualContent.js";

/** Ruta /manual (técnico) — contenido del manual dentro del marco de cuenta. */
export function ManualPage() {
  return (
    <AccountShell active="manual">
      <ManualContent />
    </AccountShell>
  );
}
